import { createAction } from "redux-actions";
import { ResultSettingConstants } from "./resultSettingConstants";

export const setResultSetting = createAction(
    ResultSettingConstants.SET_RESULT_SETTING
);
